export class OrderInfo {
  orderId: number;
  name: string;
  date: Date;
  description: string;
  amount: number;
  partnerId: number;
  invoiceUrl: string;
  ticketUrl: string;
  giftcardUrl: string;
  state: string;
  isCreditCard: boolean;

  public constructor(init?: Partial<OrderInfo>) {
    Object.assign(this, init);
  }

  static createFromAny(data: any): OrderInfo {
    if (data === null || data === undefined) {
      return null;
    }

    const orderInfo = new OrderInfo();
    orderInfo.orderId = data.orderId;
    orderInfo.name = data.name;
    orderInfo.date = new Date(data.date);
    orderInfo.description = data.description;
    orderInfo.amount = data.amount;
    orderInfo.partnerId = data.partnerId;
    orderInfo.invoiceUrl = data.invoiceUrl;
    orderInfo.ticketUrl = data.ticketUrl;
    orderInfo.giftcardUrl = data.giftcardUrl;
    orderInfo.state = data.state;
    orderInfo.isCreditCard = data.isCreditCard;
    return orderInfo;
  }

  toJSON(): any {
    return {
      name: this.name,
      date: this.date,
      description: this.description,
      amount: this.amount,
      partnerId: this.partnerId,
    };
  }

  get url(): string {
    if (this.invoiceUrl) {
      return this.invoiceUrl;
    }
    return `/order-pdf/${this.orderId}`;
  }

  get ticketPDFUrl(): string {
    if (this.ticketUrl) {
      return this.ticketUrl;
    }
    return `/ticket-pdf/${this.orderId}`;
  }

  get giftcardPDFUrl(): string {
    if (this.giftcardUrl) {
      return this.giftcardUrl;
    }
    return `/giftcard-pdf/${this.orderId}`;
  }
}
